import React, { useEffect, useState } from 'react'

const useGalleryWidth = (ref: React.RefObject<any>, trigger?: any, elemSize = 110, items = 20, maxItemsProRow?: number): { itemsPerPage: number, elementSize: number } => {
  const [itemsPerPage, setItemsPerPage] = useState<number>(items)
  const [elementSize, setElementSize] = useState<number>(elemSize)

  useEffect(() => {
    setElementSize(elemSize)
  }, [])

  useEffect(() => {
    setItemsPerPage(items)
  }, [items])

  useEffect(() => {
    let timeout: NodeJS.Timeout

    const handleResize = () => {
      if (ref.current) {
        timeout = setTimeout(() => {
          const containerWidth = ref.current.offsetWidth
          let elemProRow = Math.floor(containerWidth / elemSize)
          if (maxItemsProRow) {
            elemProRow = maxItemsProRow
            if (containerWidth < 580) {
              elemProRow = 2
            }
            if (containerWidth < 385) {
              elemProRow = 1
            }
          }

          const remainingSpace = containerWidth - (elemProRow * elementSize)
          setItemsPerPage(maxItemsProRow ? 9 : elemProRow * 4)
          setElementSize(remainingSpace / elemProRow + elementSize - 5.2) // minus 5px margin + 0.2 interference leveled
        }, 200)
      }
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
      clearTimeout(timeout)
    }
  }, [trigger, itemsPerPage, ref])

  return { itemsPerPage, elementSize }
}

export default useGalleryWidth
